<mobilize-page-header [title]="pageTitle" [reverse]="true"></mobilize-page-header>

<div class="payment-response-wrapper mobilize-card">
    @if (params.status === '0') {
        <span class="icon-mobilize-check-mark font-orange"></span>
        <p>Tranzactia Dvs. a fost efectuata cu succes! In scurt timp veti primi un mail de confirmare.</p>
        <span class="infoPaymentSpan">
            Plata efectuata cu succes va fi inregistrata in contul bancar al RCI in urmatoarea zi lucratoare si evidentiata in platforma MyMobilize in maximum 5 zile.
        </span>
    } @else {
        <span class="icon-mobilize-close"></span>
        <p>Tranzactia Dvs. nu a fost procesata. Aveti detalii in mail.</p>
    }
    <div class="actions">
        <button class="mobilize-btn btn-orange" routerLink="/dashboard">Mergi la ecranul principal</button>
    </div>
</div>
